<style lang="scss" scoped>
    .participant-detail-wrap{
        height: calc(100vh - 48px - 45px);
        overflow: auto;
        .player-info{
            width: 100% !important;
        }
    }
</style>
<template>
    <div class="participant-detail-wrap" :style="isMobile ? '' : {height: 'calc(100vh - 65px - 45px)'}" ref="participantList" v-on:scroll="handleScroll">
        <div class="participant-info-wrap">
            <p><b>{{tournament.tnmtName}}</b></p>
        </div>
        <div class="tournament-list-wrap" v-if="bestVideos">
            <div class="tournament-list" v-for="(video, videoIndex) in bestVideos.bestVideoList" :key="video.id">
                <div class="tournament-top-wrap">
                    <p class="tournament-title">{{video.gameName}}</p>
                </div>
                <div class="tournament-wrap">
                    <div class="thumbnail" style="cursor:pointer;" :style="{backgroundImage: `url('${video.thumbnail}')`}" @click="broadCastFunc(video)"><div class="play-btn"/></div>
                    <div class="tournament-info-wrap">

                        <table>
                            <tr>
                                <td class="player-info-wrap">
                                    <div class="player-info">
                                        <p class="team">{{video.firstTeamName}}</p>
                                        <p class="player">
                                            {{video.firstPlayer}}
                                        </p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="player-info-wrap">
                                    <div class="player-info">
                                        <p class="team">{{video.secondTeamName}}</p>
                                        <p class="player">
                                            {{video.secondPlayer}}
                                        </p>
                                    </div>
                                </td>
                            </tr>
                        </table>

                    </div>
                </div>
            </div>
        </div>
        <EmptyContent v-else content="검색결과가 없습니다" style="height: calc(100% - 55px)"></EmptyContent>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import EmptyContent from "../../common/EmptyContent";
    export default{
        components: {EmptyContent},
        computed:{
            ...mapState('tournaments', ['tournament', 'bestVideos'])
        },
        data(){
            return{
                moreVideoIndex: []
            }
        },
        methods: {
            openMoreInfo(videoIndex){
                if(this.moreVideoIndex.includes(videoIndex)){
                    const index = this.moreVideoIndex.indexOf(videoIndex)
                    this.moreVideoIndex.splice(index, 1)
                }else{
                    this.moreVideoIndex.push(videoIndex)
                }

            },
            broadCastFunc(video){
                if(video.broadcastUrl){
                    window.open(video.broadcastUrl)
                }
            },

            handleScroll(event){
                const scrollTop = event.target.scrollTop
                localStorage.setItem('best-video-scroll', scrollTop)
            },
        },
        mounted() {
            if(localStorage.getItem('best-video-scroll')){
                this.$refs.participantList.scrollTop = localStorage.getItem('best-video-scroll')
                localStorage.removeItem('best-video-scroll')
            }
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);
        },
        created() {
            window.addEventListener('scroll', this.handleScroll)
        },
    }
</script>
